import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Certificate } from "src/app/models/Certificate";
import { EventDocument } from "src/app/models/EventDocument";
import { RaRequestResponse } from "src/app/models/RaRequestResponse";
import { environment } from "src/environments/environment";

import ApiVersionConstants from "../constants/api-version-constants";
import { RaOptions } from "../models/RaOptions";
import { DocType } from "./../models/Enums";
import { PoSubmit } from "./../models/PoSubmit";
import { ServiceRequest } from "./../models/ServiceRequest";

@Injectable({
  providedIn: "root",
})
export class EventService {
  private baseUrl_V2 = `${environment.apiConfig.uri}/${ApiVersionConstants.V_2}/event`;

  constructor(private http: HttpClient) {}

  public docUrl = (d: EventDocument) =>
    `${this.baseUrl_V2}/${d.eventNumber}/document/${encodeURIComponent(d.number)}`;

  public certificateUrl = (c: Certificate) =>
    `${this.baseUrl_V2}/${c.eventNumber}/certificate/${c.certificateNumber}`;

  getDocument(d: EventDocument | Certificate): Observable<Blob> {
    const url =
      d.documentType === DocType.Certificate
        ? this.certificateUrl(d as Certificate)
        : this.docUrl(d as EventDocument);
    return this.http.get(url, { responseType: "blob" });
  }

  submitPurchaseOrder(po: PoSubmit, file: File | undefined) {
    const formData = this.getFormData(po, file);
    return this.http.post(`${this.baseUrl_V2}/po`, formData);
  }

  submitServiceRequest(ra: ServiceRequest, file: File | undefined): Observable<RaRequestResponse> {
    const formData = this.getFormData(ra, file);
    return this.http.post<RaRequestResponse>(`${this.baseUrl_V2}/ra`, formData);
  }

  getRaOptions(companyId: string): Observable<RaOptions> {
    return this.http.get<RaOptions>(`${this.baseUrl_V2}/raOptions/${companyId}`);
  }

  private getFormData<T>(entity: T, file: File | undefined): FormData {
    const formData = new FormData();

    if (file) {
      formData.append("file", file);
    }

    formData.append("entity", JSON.stringify(entity));

    return formData;
  }
}
